/**
 * Blog Grid - Category Filter
 */
(function () {
  'use strict';

  var section = document.querySelector('.blog-grid');
  if (!section) return;

  var filterBtns = section.querySelectorAll('.blog-grid__filter-btn');
  var cards = section.querySelectorAll('.blog-grid__card');

  filterBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      filterBtns.forEach(function (b) {
        b.classList.remove('blog-grid__filter-btn--active');
      });
      btn.classList.add('blog-grid__filter-btn--active');

      var filter = btn.getAttribute('data-filter');

      cards.forEach(function (card) {
        if (filter === 'all') {
          card.classList.remove('blog-grid__card--hidden');
          return;
        }
        var tags = card.getAttribute('data-tags');
        if (tags && tags.split(',').indexOf(filter) !== -1) {
          card.classList.remove('blog-grid__card--hidden');
        } else {
          card.classList.add('blog-grid__card--hidden');
        }
      });
    });
  });
})();
